import type { AdnConfig } from '../../config/adn/types';

const config: AdnConfig<'vgtv'> = {
  vgtv: {
    member: 9700,
    placements: {
      preroll: {
        phone: '14096849',
        tablet: '14096853',
        desktop: '14096840',
      },
      bumper: {
        phone: '14096760',
        tablet: '14096777',
        desktop: '14096698',
      },
      sponsorroll: {
        phone: '21675765',
        tablet: '21675767',
        desktop: '21675764',
      },
      pausead: {
        phone: 'no-vgtv-wph-other_netboard_pausead',
        tablet: 'no-vgtv-wtb-other_netboard_pausead',
        desktop: 'no-vgtv-wde-other_netboard_pausead',
      },
      postroll: {
        phone: '14096830',
        tablet: '14096829',
        desktop: '14096828',
      },
      midroll: {
        phone: '14096847',
        tablet: '14096851',
        desktop: '14096838',
      },
      longform: {
        phone: '14935116',
        tablet: '14935125',
        desktop: '14935102',
      },
    },
    keywords: {
      pageType: 'front',
      publisherName: 'vgtv',
      publisherGroup: 'schibsted',
    },
    glimr: {
      enabled: true,
      keywordPrefix: 'kw_no-sno',
      country: 'no',
      clientId: 'H3IYO2A4LD43YPFZIJLN',
      schibstedAdChoicesEnabled: true,
    },
  },
  vg: {
    member: 9700,
    placements: {
      bumper: {
        desktop: '14096585',
        phone: '14096746',
        tablet: '14096763',
      },
      pausead: {
        phone: 'no-vg-wph-article_netboard_pausead',
        tablet: 'no-vg-wtb-article_netboard_pausead',
        desktop: 'no-vg-wde-article_netboard_pausead',
      },
      preroll: {
        desktop: '14096681',
        phone: '14096747',
        tablet: '14096770',
      },
      bumper_stories: {
        desktop: '35595617',
        phone: '35595618',
        tablet: '35595619',
      },
      sponsorroll: {
        phone: '22435702',
        tablet: '22435703',
        desktop: '22435700',
      },
      midroll: {
        phone: '14096738',
        tablet: '14096764',
        desktop: '14096673',
      },
      longform: {
        phone: '14935197',
        tablet: '14935205',
        desktop: '14935157',
      },
    },
    keywords: {
      pageType: 'article',
      publisherName: 'vg',
      publisherGroup: 'schibsted',
    },
    glimr: {
      enabled: true,
      keywordPrefix: 'kw_no-sno',
      country: 'no',
      clientId: 'H3IYO2A4LD43YPFZIJLN',
      schibstedAdChoicesEnabled: true,
    },
  },
  direkte: {
    member: 9700,
    placements: {
      preroll: {
        desktop: '14096806',
        tablet: '14096808',
        phone: '14096807',
      },
      bumper: {
        desktop: '15852956',
        tablet: '15853021',
        phone: '15852946',
      },
      sponsorroll: {
        phone: '16093185',
        tablet: '16093249',
        desktop: '16093189',
      },
      midroll: {
        phone: '16700422',
        tablet: '16700507',
        desktop: '16700482',
      },
      pausead: {
        phone: 'no-vgdirekte-wph-other_netboard_pausead',
        tablet: 'no-vgdirekte-wtb-other_netboard_pausead',
        desktop: 'no-vgdirekte-wde-other_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'front',
      publisherName: 'vgdirekte',
      publisherGroup: 'schibsted',
    },
  },
  vglive: {
    member: 9700,
    placements: {
      preroll: {
        phone: '16185716',
        tablet: '16185857',
        desktop: '16185804',
      },
      bumper: {
        phone: '16185709',
        tablet: '16185848',
        desktop: '16185730',
      },
      midroll: {
        phone: '16185731',
        tablet: '16185920',
        desktop: '16185825',
      },
      longform: {
        phone: '16185717',
        tablet: '16185866',
        desktop: '16185810',
      },
      pausead: {
        phone: 'no-vglive-wph-other_netboard_pausead',
        tablet: 'no-vglive-wtb-other_netboard_pausead',
        desktop: 'no-vglive-wde-other_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'front',
      publisherName: 'vglive',
      publisherGroup: 'schibsted',
    },
  },
  tek: {
    member: 9700,
    placements: {
      preroll: {
        phone: '18174992',
        tablet: '18175004',
        desktop: '18174987',
      },
      bumper: {
        phone: '18293359',
        tablet: '18293376',
        desktop: '18293316',
      },
      midroll: {
        phone: '18281279',
        tablet: '18281414',
        desktop: '18281026',
      },
      longform: {
        phone: '18281304',
        tablet: '18281438',
        desktop: '18281131',
      },
      pausead: {
        phone: 'no-tek-wph-article_netboard_pausead',
        tablet: 'no-tek-wtb-article_netboard_pausead',
        desktop: 'no-tek-wde-article_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'article',
      publisherName: 'no-tek',
      publisherGroup: 'schibsted',
    },
  },
  godt: {
    member: 9700,
    placements: {
      preroll: {
        phone: '18281764',
        tablet: '18281785',
        desktop: '18281742',
      },
      bumper: {
        phone: '18293405',
        tablet: '18293398',
        desktop: '18293392',
      },
      midroll: {
        phone: '18281770',
        tablet: '18281795',
        desktop: '18281747',
      },
      longform: {
        phone: '18281766',
        tablet: '18281787',
        desktop: '18281744',
      },
      pausead: {
        phone: 'no-godt-wph-article_netboard_pausead',
        tablet: 'no-godt-wtb-article_netboard_pausead',
        desktop: 'no-godt-wde-article_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'article',
      publisherName: 'godt',
      publisherGroup: 'schibsted',
    },
  },
  godt_other: {
    member: 9700,
    placements: {
      preroll: {
        phone: '18281953',
        tablet: '18281960',
        desktop: '18281935',
      },
      midroll: {
        phone: '18281955',
        tablet: '18281962',
        desktop: '18281937',
      },
      longform: {
        phone: '18281954',
        tablet: '18281961',
        desktop: '18281936',
      },
      pausead: {
        phone: 'no-godt-wph-other_netboard_pausead',
        tablet: 'no-godt-wtb-other_netboard_pausead',
        desktop: 'no-godt-wde-other_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'other',
      publisherName: 'godt',
      publisherGroup: 'schibsted',
    },
  },
  minmote: {
    member: 9700,
    placements: {
      preroll: {
        phone: '18281858',
        tablet: '18281865',
        desktop: '18281812',
      },
      bumper: {
        phone: '18293454',
        tablet: '18293464',
        desktop: '18293442',
      },
      midroll: {
        phone: '18281863',
        tablet: '18281871',
        desktop: '18281825',
      },
      longform: {
        phone: '18281860',
        tablet: '18281867',
        desktop: '18281818',
      },
      pausead: {
        phone: 'no-minmote-wph-article_netboard_pausead',
        tablet: 'no-minmote-wtb-article_netboard_pausead',
        desktop: 'no-minmote-wde-article_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'article',
      publisherName: 'minmote',
      publisherGroup: 'schibsted',
    },
  },
  minmote_other: {
    member: 9700,
    placements: {
      preroll: {
        phone: '18282035',
        tablet: '18282044',
        desktop: '18281812',
      },
      midroll: {
        phone: '18282037',
        tablet: '18282047',
        desktop: '18281825',
      },
      longform: {
        phone: '18282036',
        tablet: '18282045',
        desktop: '18281818',
      },
      pausead: {
        phone: 'no-minmote-wph-other_netboard_pausead',
        tablet: 'no-minmote-wtb-other_netboard_pausead',
        desktop: 'no-minmote-wde-other_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'other',
      publisherName: 'minmote',
      publisherGroup: 'schibsted',
    },
  },
  e24_front: {
    member: 9700,
    placements: {
      preroll: {
        phone: '21147537',
        tablet: '21147492',
        desktop: '21147441',
      },
      bumper: {
        phone: '19675712',
        tablet: '19675686',
        desktop: '19675668',
      },
    },
    keywords: {
      pageType: 'front',
      publisherName: 'e24',
      publisherGroup: 'schibsted',
    },
  },
  e24_article: {
    member: 9700,
    placements: {
      preroll: {
        phone: '18282089',
        tablet: '18282094',
        desktop: '18282062',
      },
      bumper: {
        phone: '18293486',
        tablet: '18293499',
        desktop: '18293484',
      },
      midroll: {
        phone: '18282092',
        tablet: '18282104',
        desktop: '18282077',
      },
      longform: {
        phone: '18282090',
        tablet: '18282099',
        desktop: '18282075',
      },
      pausead: {
        phone: 'no-e24-wph-article_netboard_pausead',
        tablet: 'no-e24-wtb-article_netboard_pausead',
        desktop: 'no-e24-wde-article_netboard_pausead',
      },
    },
    keywords: {
      pageType: 'article',
      publisherName: 'e24',
      publisherGroup: 'schibsted',
    },
  },
  e24_direkte: {
    member: 9700,
    placements: {
      preroll: {
        phone: '19675913',
        tablet: '19675911',
        desktop: '19675910',
      },
      bumper: {
        phone: '19675738',
        tablet: '19675699',
        desktop: '19675670',
      },
    },
    keywords: {
      pageType: 'front',
      publisherName: 'e24',
      publisherGroup: 'schibsted',
    },
  },
} satisfies AdnConfig<'vgtv'>;

export default {
  ...config,
  e24: config.e24_article,
} as AdnConfig<'vgtv'>;
